export default [
  ['=', '+', '%', '*', '[', ']', '{', '}', '<', '>'],
  ['@', ':', ';', '_', '-', '#', '(', ')', '/', '\\'],
  ['.', ',', '?', '!', '\'', '"', '^'],
];
